
import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_6468_19293)">
      <path d="M4.16162 14.4952L1.33319 11.6668L4.16162 8.83838" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.33333 11.6667L8.96647 11.6667" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.7715 1.65467L14.5999 4.4831L11.7715 7.31152" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5998 4.48323L6.96663 4.48323" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_6468_19293">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);


export default Icon
